import { render, staticRenderFns } from "./PartnerForm.vue?vue&type=template&id=937cdfc6"
import script from "./PartnerForm.vue?vue&type=script&lang=js"
export * from "./PartnerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports